import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const softwareSecurityClassicRoute: InvariantJiraRoute = {
	name: 'software-security-classic',
	path: '/jira/software/c/projects/:projectKey/security',
};
